import { Event } from '../trackers/Tracking'
import { sendPhotographerEmail, sendMarketplacePhotographerEmail } from 'apiCalls/PhotographerRequests'
import { profilePageIcons } from 'components/admin/Images'
import { sendEmailFormValidation } from 'components/validation/SendEmailFormValidation'
import { useAppContext } from 'context/AppContext'
import useForm from 'hooks/AuthHooks'
import React, { useState } from 'react'
import ReactGA from 'react-ga'
import { BiMailSend, BiPhoneCall } from 'react-icons/bi'
import styled, { keyframes } from 'styled-components'

const { messagesImg } = profilePageIcons

export function PublicPackageButton({
  buttonTitle,
  companyName,
  interest,
  photographerID,
  displayPage,
  option,
  phone,
  isForPreview,
}) {
  const [open, setOpen] = useState(false)
  const [clicked, setClicked] = useState(false)

  return (
    <React.Fragment>
      <EmailDetailsModal
        open={open}
        setOpen={setOpen}
        companyName={companyName}
        interest={interest}
        photographerID={photographerID}
      />
      {option === 'message' && (
        <MiniSessionButton
          onClick={() => {
            Event(
              'MESSAGE',
              `Message modal open through PACKAGE at ${window.location.origin}`,
              'MESSAGE_MODAL',
            )
            setOpen(true)
          }}
          isForPreview={isForPreview}
        >
          {/* <MessageIcon /> */}
          <img src={messagesImg} alt="message" />
          <H1 displayPage={displayPage}>{buttonTitle}</H1>
        </MiniSessionButton>
      )}
      {option === 'call' && (
        <React.Fragment>
          {!clicked ? (
            <Button2
              id="public-portfolio-call-button"
              onClick={() => {
                setClicked(true)
              }}
              right
            >
              <CallIcon />
              Phone
            </Button2>
          ) : (
            <CallLink href={`tel:${phone}`}>
              <Button2
                id="public-portfolio-call-button"
                onClick={() => {
                  Event(
                    'CALL',
                    `Call button clicked through PORTFOLIO at ${window.location.origin}`,
                    'CALL_BUTTON',
                  )
                }}
                right
              >
                <CallIcon />
                {phone}
              </Button2>
            </CallLink>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export function MarketplacePackageButton({
  buttonTitle,
  companyName,
  interest,
  photographerID,
  displayPage,
}) {
  const [open, setOpen] = useState(false)

  return (
    <React.Fragment>
      <EmailDetailsModal
        open={open}
        setOpen={setOpen}
        companyName={companyName}
        interest={interest}
        photographerID={photographerID}
      />
      <Div4
        onClick={() => {
          Event('MESSAGE', `Message modal open through PACKAGE at ${window.location.origin}`, 'MESSAGE_MODAL')
          setOpen(true)
        }}
      >
        <Button displayPage={displayPage}>
          <MessageIcon1 />
          {buttonTitle}
        </Button>
      </Div4>
    </React.Fragment>
  )
}

export function PublicPortfolioButton({
  companyName,
  interest,
  photographerID,
  displayPage,
  option,
  phone,
  font,
  isMarginBottom = 0,
}) {
  const [open, setOpen] = useState(false)
  const [clicked, setClicked] = useState(false)
  return (
    <React.Fragment>
      <EmailDetailsModal
        open={open}
        setOpen={setOpen}
        companyName={companyName}
        interest={interest}
        photographerID={photographerID}
      />
      {option === 'message' && (
        <Button3
          isMarginBottom={isMarginBottom}
          id="public-portfolio-message-button"
          onClick={() => {
            Event(
              'MESSAGE',
              `Message modal open through PORTFOLIO at ${window.location.origin}`,
              'MESSAGE_MODAL',
            )
            setOpen(true)
          }}
          font={font}
        >
          <MessageIcon /> Message
        </Button3>
      )}
      {option === 'call' && (
        <React.Fragment>
          {!clicked ? (
            <Button3
              id="public-portfolio-call-button"
              onClick={() => {
                setClicked(true)
              }}
              font={font}
            >
              <CallIcon />
              Phone
            </Button3>
          ) : (
            <CallLink href={`tel:${phone}`}>
              <Button3
                id="public-portfolio-call-button"
                onClick={() => {
                  Event(
                    'CALL',
                    `Call button clicked through PORTFOLIO at ${window.location.origin}`,
                    'CALL_BUTTON',
                  )
                }}
                font={font}
              >
                <CallIcon />
                {phone}
              </Button3>
            </CallLink>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

function EmailDetailsModal({ open, setOpen, companyName, interest, photographerID }) {
  const [, dispatch] = useAppContext()

  const { values, setValues, handleChange, handleSubmit, errors } = useForm(
    sendEmail,
    sendEmailFormValidation,
  )

  async function sendEmail() {
    let response
    // IF PAGE IS A MARKETPLACE PAGE (MARKETPLACE-PACKAGE ETC) THEN USE THE MARKETPLACE INQUIRY SENDGRID NOTIFICATION
    if (window.location.pathname.includes('marketplace')) {
      response = await sendMarketplacePhotographerEmail({ ...values, interest }, photographerID)
    } else {
      response = await sendPhotographerEmail({ ...values, interest }, photographerID)
    }
    if (response.status === 204) {
      dispatch({
        type: 'setAlertType',
        alertType: 'success',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['Your message has been sent. You will receive a copy'],
      })

      ReactGA.event({
        category: 'Messages',
        action: 'Inquiry message sent',
        label: interest,
      })
      setValues({})
    } else {
      dispatch({
        type: 'setAlertType',
        alertType: 'error',
      })
      dispatch({
        type: 'setAlertText',
        alertText: ['Failed To Send Message.'],
      })
      throw new Error(response.data)
    }
    setOpen(false)
  }

  if (open) {
    let scrollbarWidth = window.innerWidth - document.body.clientWidth + 'px'
    document.body.style.overflow = 'hidden'
    document.body.style.margin = `0 ${scrollbarWidth} 0 0`
  } else {
    document.body.style.overflow = 'visible'
    document.body.style.margin = '0'
  }

  return (
    <Container open={open}>
      <Modal id="modal-scroll-lock" isOpen={open} toggle={() => setOpen(!open)}>
        <ModalHeader>
          <H3>Email To {companyName}</H3>
          <CloseButton
            id="close-message-handler"
            aria-label="Close"
            data-dismiss="modal"
            type="button"
            onClick={() => setOpen(false)}
          >
            <span aria-hidden={true}>×</span>
          </CloseButton>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <Label>Email</Label>
            <FormGroup>
              <Input
                id="message-handler-email"
                name="email"
                type="text"
                required
                value={values.email || ''}
                invalid={!!errors.email}
                onChange={handleChange}
                placeholder={'name@email.com'}
                style={{ fontSize: '16px' }}
              />
              <FormFeedback id="message-handler-email-error">{errors.email}</FormFeedback>
            </FormGroup>
            <Label>Name</Label>
            <FormGroup>
              <Input
                id="message-handler-name"
                name="name"
                type="text"
                required
                value={values.name || ''}
                invalid={!!errors.name}
                onChange={handleChange}
                style={{ fontSize: '16px' }}
              />
              <FormFeedback id="message-handler-name-error">{errors.name}</FormFeedback>
            </FormGroup>
            <Label>Phone</Label>
            <FormGroup>
              <Input
                id="message-handler-phone"
                name="phoneNumber"
                type="text"
                required
                value={values.phoneNumber || ''}
                invalid={!!errors.phoneNumber}
                onChange={handleChange}
                placeholder={'123-456-7890'}
                style={{ fontSize: '16px' }}
              />
              <FormFeedback id="message-handler-phone-error">{errors.phoneNumber}</FormFeedback>
            </FormGroup>
            <Label>Message</Label>
            <SubLabel>
              Let me know if you have a specific date/time for your session. Tell me about your session
            </SubLabel>
            <FormGroup>
              <Textarea
                id="message-handler-message"
                name="message"
                style={{ height: '10rem', fontSize: '16px' }}
                type="textarea"
                required
                value={values.message || ''}
                onChange={handleChange}
              />
            </FormGroup>
            <SendButton type="submit">Send</SendButton>
            <H4PaddedTop>You will receive a copy of this email</H4PaddedTop>
          </Form>
        </ModalBody>
      </Modal>
      <ScreenDimmer open={open} onClick={() => setOpen(false)}></ScreenDimmer>
    </Container>
  )
}

const Button2 = styled.button`
  opacity: 0.9;
  padding: 0.5em 1.5em;
  margin: ${(props) => (props.right ? '0.5em 0 0.5em 0.8em' : '0.5em 0')};
  box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
  color: white;
  background-color: var(--black);
  :hover {
    transform: ${(props) => (props.disabled ? 'translateY(0%)' : 'translateY(-2%)')};
  }
  @media (max-width: 1300px) {
    padding: 0.4em 0.6em;
  }

  @media (max-width: 550px) {
    width: 80%;
    font-size: 1.8em;
    margin: 1em 0;
    height: 35px;
  }
`

const MiniSessionButton = styled.button`
  margin: 2em 0 1em 0;
  color: var(--black);
  padding: 0.5em 1.5em;
  background-color: #fff;
  border: 1px solid var(--form-grey);
  border-radius: ${(props) => (props.isForPreview ? '0' : '0.3em')};
  @media (max-width: 550px) {
    color: white;
    background-color: var(--black);
    width: 100%;
    font-size: 1.8em;
    margin: 1em 0;
    height: auto;
  }
`

const Div4 = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5em 0;
  font-size: 1.3em;
  width: 100%;
  cursor: pointer;
  :hover {
    opacity: 0.8;
  }
  @media (max-width: 500px) {
    font-size: 1.8em;
    margin: 1em 0;
  }
`

const CloseButton = styled.button`
  float: right;
  font-size: 1.5rem;
  line-height: 1;
  color: rgba(0, 0, 0, 0.6);
  text-shadow: none;
  opacity: 0.5;
  transition: all 0.15s ease;
  padding: 1.25rem;
  margin: -1.25rem -1.25rem -1.25rem auto;
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  :hover {
    color: rgba(0, 0, 0, 0.6);
    text-decoration: none;
    opacity: 0.75;
    transform: none;
  }
`

const SendButton = styled.button`
  font-size: 0.875rem;
  border: 1px solid transparent;
  width: 100%;
  padding: 0.875rem 1rem;
  transition: all 0.15s ease;
  letter-spacing: 0.025em;
  will-change: transform;
  color: #fff;
  background-color: var(--black);
  border-color: var(--black);
`

const H1 = styled.h4`
  font-size: 18px;
  font-family: inherit;
`

const H4PaddedTop = styled.h4`
  padding-top: 2em;
  font-size: 0.9375rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.5;
  color: var(--black);
`

const fadeIn = keyframes`
  0% {
    top: -100%;
    opacity: 0;
  }
  100% {
      top: 0%;
      opacity: 1;
  }
`

const Modal = styled.div`
  position: absolute;
  left: 50%;
  top: 0%;
  transform: translate(-50%, -5%);
  width: 31.25em;
  background: white;
  z-index: 999;
  margin: 4em 0;
  border-radius: 0.3em;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17);
  font-size: 16px;
  animation: 1s ${fadeIn} ease-out;
  @media (max-width: 550px) {
    font-size: 15px;
    height: auto;
  }
  @media (max-width: 500px) {
    font-size: 14px;
  }
  @media (max-width: 480px) {
    font-size: 13px;
  }
  @media (max-width: 450px) {
    width: 95%;
  }
`
const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  padding: 0 1.2em 1em 1.2em;
`
const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1.25rem;
  border-bottom: 0 solid var(--light-grey-2);
  border-top-left-radius: 0.4375rem;
  border-top-right-radius: 0.4375rem;
`

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: ${(props) => (props.open ? 'flex' : 'none')};
  z-index: 9999;
  overflow-y: scroll;
`

const ScreenDimmer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: ${(props) => (props.open ? 'block' : 'none')};
  background: black;
  z-index: 1;
  opacity: 0.3;
`
const H3 = styled.h4`
  margin-bottom: 0.5rem;
  line-height: 1.5;
  color: var(--black);
  font-size: 1.625em;
`

const Form = styled.form`
  display: block;
`

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`

const FormFeedback = styled.div`
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #fb6340;
`

const Input = styled.input`
  display: block;
  width: 100%;
  height: calc(2.75rem + 2px);
  padding: 0.625rem 0.75rem;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  transition: all 0.15s ease-in-out;
`

const Textarea = styled.textarea`
  display: block;
  width: 100%;
  height: calc(2.75rem + 2px);
  padding: 0.625rem 0.75rem;
  line-height: 1.5;
  color: #8898aa;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 3px 2px rgba(233, 236, 239, 0.05);
  transition: all 0.15s ease-in-out;
`

const Label = styled.label`
  display: inline-block;
  margin-bottom: 0.5rem;
  color: var(--black);
`

const SubLabel = styled.h6`
  margin-bottom: 0.5rem;
  font-size: 0.72em;
  color: var(--light-grey-1);
`

const Button3 = styled.button`
  color: var(--black);
  background: white;
  padding: 0.5em 1.5em;
  margin: 0.5em 1em;
  font-family: ${(props) => !!props.font && props.font};
  @media (max-width: 1400px) {
    margin: 0.5em 0.4em;
    padding: 0.2em 0.6em;
  }
  @media (max-width: 1150px) {
    font-size: 1.2em;
  }
  @media (max-width: 1000px) {
    margin-bottom: ${({ isMarginBottom }) => isMarginBottom}px;
  }
`
const MessageIcon = styled(BiMailSend)`
  font-size: 16px;
  margin: 0.1em 0.5em 0 0;
  @media (max-width: 550px) {
    font-size: 20px;
  }
`

const MessageIcon1 = styled(BiMailSend)`
  font-size: 20px;
  margin: 0 0.5em 0 0;
`

const CallIcon = styled(BiPhoneCall)`
  font-size: 16px;
  margin: 0.1em 0.5em 0 0;
`
const CallLink = styled.a`
  text-decoration: none;
  width: inherit;
`
const Button = styled.button`
  font-size: 16px;
  background-color: var(--forward);
  font-weight: 500;
  width: 100%;
  :hover {
    background-color: var(--dark-yellow);
    transition: all 0.2s ease 0s;
    box-shadow: rgb(4 17 29 / 25%) 0px 0px 8px 0px;
  }
`
